// @flow

import makeStore from '@leasen_nl/listo/src/helpers/makeStore';
import createRootReducer from './combineReducers';

export default makeStore(createRootReducer);
